import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { switchMap } from 'rxjs';
import { environment } from '../../environments/environment';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  // GeographyService always requests `${environment.geographyApiUrl}/api/Geography`
  // — an empty geographyApiUrl (LocalDev) reduces that to the relative
  // '/api/Geography' path proxied by the dev-server, so this matches both cases.
  const isVigilant  = req.url.startsWith(environment.vigilantApiUrl);
  const isGeography = req.url.startsWith(`${environment.geographyApiUrl}/api/Geography`);
  if (!isVigilant && !isGeography) {
    return next(req);
  }
  const oidc = inject(OidcSecurityService);
  return oidc.getAccessToken().pipe(
    switchMap(token => {
      if (!token) return next(req);
      return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
    })
  );
};
